import { DesignParams, designParamsSchema } from '../../commerce';
import { getSearchString } from '../../utils';

export const StoreRoutes = (storeId: string) => {
	const base = `/${storeId}`;
	const billing = `${base}/billing`;

	return {
		Dashboard: `${base}`,
		Billing: {
			Landing: billing,
			Payment: {
				Add: `${billing}/add`,
				View: (id: string) => `${billing}/payment/${id}`,
			},
			Invoices: {
				Landing: `${billing}/invoices`,
				View: (id: string) => `${billing}/invoices/${id}`,
			},
			Refunds: {
				Landing: `${billing}/refunds`,
				Download: (id: string) => `${billing}/refunds/${id}.pdf`,
			},
		},
		Api: {
			StoreDesigns: `${base}/api/store-designs`,
			UpdateCollection: `${base}/api/update-collection`,
			UpdateMainDecoration: `${base}/api/update-main-decoration`,
			ProductSearch: `${base}/api/product-search`,
		},
		Designs: {
			Landing: `${base}/designs`,
			View: (id: string) => `${base}/designs/${id}`,
		},
		Merch: {
			Landing: `${base}/merch`,
			View: (id: string) => `${base}/merch/${id}`,
			Edit: (id: string) => `${base}/merch/${id}/edit`,
			Add: `${base}/merch/add`,
			Design: (productSlug: string, params?: DesignParams) =>
				`${base}/merch/add/${productSlug.toLowerCase()}${getSearchString(params, designParamsSchema)}`,
			Link: (id: string) => ({
				Landing: `${base}/merch/${id}/link`,
				New: `${base}/merch/${id}/link/new`,
				Existing: (reference?: boolean) => ({
					Listing: `${base}/merch/${id}/link/existing${reference ? '?reference=true' : ''}`,
					Product: (productId: string) => `${base}/merch/${id}/link/existing/${productId}${reference ? '?reference=true' : ''}`,
				}),
			}),
		},
		Collections: {
			Landing: `${base}/collections`,
			View: (id: string) => `${base}/collections/${id}`,
		},
		Bulk: `${base}/bulk`,
		Orders: {
			Landing: `${base}/orders`,
			View: (id: string) => `${base}/orders/${id}`,
			Export: `${base}/orders/export.xlsx`,
		},
		Settings: {
			Landing: `${base}/settings`,
			Profile: `${base}/settings/profile`,
		},
		Statistics: `${base}/statistics`,
		Integration: `${base}/shopify`,
	};
};
